import React from "react";
import types from "../ui-components/constants/status-types-config";
import ConfiguratorSurveyBlockHeader from "./ConfiguratorSurveyBlockHeader";
import ConfiguratorSurveyAlertTCS from "./ConfiguratorSurveyAlertTCS";
import TranslatedKey from "./TranslatedKey";

const ConfiguratorSurveyAlert = ({ alert, role, saveResponses }) => {
  const { title, description, image_filename, hidden_question } = alert;

  const alert_type = alert.alert_type || "info";
  if (!types[alert_type]) {
    throw new Error("missing alert type");
  }

  const {
    Icon,
    classes: { light, textRegular },
  } = types[alert_type];

  const hidden = hidden_question.includes(`role_type_${role}`) ? "hidden" : "";

  return (
    <div className={`w-full flex mb-8 p-4 items-center ${light} ${hidden}`}>
      <div className="flex-shrink-0 mr-4">
        {Icon && (
          <Icon className={`h-10 w-10 ${textRegular}`} aria-hidden="true" />
        )}
      </div>

      {alert_type === "image" ? (
        <div className="flex flex-col gap-5 w-full">
          {title && (
            <h2 className="text-xl">
              <TranslatedKey id={title} />
            </h2>
          )}
          {description && (
            <div>
              <TranslatedKey id={description} />
            </div>
          )}
          <img
            src={`/${image_filename}`}
            alt={title}
            style={{ maxHeight: "300px" }}
            className="max-w-full h-full max-h-[300px] object-contain m-auto"
          />
        </div>
      ) : alert_type === "tcs" ? (
        <ConfiguratorSurveyAlertTCS
          metadata={alert.metadata_}
          title={title}
          alertId={alert.id}
          saveResponses={saveResponses}
        />
      ) : (
        <ConfiguratorSurveyBlockHeader
          title={title}
          description={description}
          image_filename={image_filename}
          hidden={hidden}
          type="alert"
        />
      )}
    </div>
  );
};

export default ConfiguratorSurveyAlert;
